import { createContext } from 'react';

const permissionState = { permission: undefined, setPermission: undefined }

export const PermissionContext = createContext(permissionState);